module.exports = __webpack_public_path__ + "img/img_alion.cf4a6947.jpg";